import { App } from '@mb/App';
import { createRoot } from 'react-dom/client';

import { ThemeContainer } from 'ui-widgets';
import { CollectionHeader } from '../../../pages/CollectionHeader/CollectionHeader';

const CollectionHeaderApp = () => {
  return (
    <App>
      <ThemeContainer>
        <CollectionHeader />
      </ThemeContainer>
    </App>
  );
};

const container = document.getElementById('collectionHeader');
const root = createRoot(container!);
root.render(<CollectionHeaderApp />);
